export default __webpack_public_path__ + "static/media/handbook.616a549d.md";